module.exports = __webpack_public_path__ + "src/assets/svgs/landing/GotAQuestion/app-store-button.svg";